export type GetPageMetaRequest = {
  pathname: string;
};

export type PageMeta = {
  title: string;
  description: string;
  type: string;
  url: string;
  robots?: string;
  locale?: string;
  siteName?: string;
  image?: string;
  seoSchema?: Record<string, unknown>;
};
export type GetPageMetaResponse = PageMeta;
